import { render } from "./BlFormFieldScore.vue?vue&type=template&id=d089326e&scoped=true"
import script from "./BlFormFieldScore.vue?vue&type=script&lang=js"
export * from "./BlFormFieldScore.vue?vue&type=script&lang=js"

import "./BlFormFieldScore.vue?vue&type=style&index=0&id=d089326e&scoped=true&lang=scss"

import exportComponent from "/var/www/blocks/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d089326e"]])

export default __exports__